import React from 'react';
import { HiShare } from 'react-icons/hi2';

const ShareBookingButton = ({ bookingId, customerName }) => {
    const handleShare = async (e) => {
        e.stopPropagation(); // Prevent triggering parent click events

        const link = `${window.location.origin}/?joinBukber=${bookingId}`;
        // Use encodeURIComponent for safety, though browser share usually handles it
        const text = `Yuk gabung bukber bareng ${customerName}! Klik link ini untuk pilih menumu: ${link}`;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Gabung Bukber',
                    text: text,
                    url: link,
                });
            } catch (err) {
                console.error('Error sharing:', err);
            }
        } else {
            // Fallback copy to clipboard
            try {
                await navigator.clipboard.writeText(text);
                alert('Link bukber disalin ke clipboard! Kirim ke teman-temanmu ya.');
            } catch (err) {
                console.error('Failed to copy', err);
                prompt('Copy link ini manual ya:', text);
            }
        }
    };

    return (
        <button
            onClick={handleShare}
            className="flex items-center gap-1.5 bg-emerald-100 text-emerald-700 px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-emerald-200 transition-colors z-10"
            title="Bagikan Link Bukber"
        >
            <HiShare size={14} />
            <span>Undang Teman</span>
        </button>
    );
};

export default ShareBookingButton;
